<template>
  <div class="home_category productDetailCommentTab">
    <h4 class="heading">
      {{$t('feedback')}}
      <span
        v-if="ratingObject.commentDTOs && ratingObject.commentDTOs.length > 0"
      >({{ratingObject.totalRatingCount}})</span>
    </h4>
    <div v-if="ratingObject.commentDTOs && ratingObject.commentDTOs.length > 0">
      <ul class="progress_bars">
        <li v-for="(productrating,index) in ratingObject.productRatingDTOs" :key="index">
          <h4>
            {{productrating.name}}
            <span
              style="font-size: 0.875em;"
            >({{productrating.rating}} out of 5)</span>
          </h4>
          <div class="feedback-bar">
            <span :style="`width: ${productrating.rating*20}%`"></span>
          </div>
        </li>
      </ul>
      <ul class="feedback-list">
        <li v-for="(rating,index) in ratingObject.commentDTOs.slice(0, 10)" :key="index">
          <span class="user-img" v-if="rating.xAuthId" @click="openUserProfile(rating.xAuthId)">
            <img :src="rating.profileImage" class="wdth100" alt="dummy" v-if="rating.profileImage" />
          <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" v-else />
          </span>
          <span class="user-img" v-else>
            <img :src="rating.profileImage" class="wdth100" alt="dummy" v-if="rating.profileImage" />
          <img src="../../assets/images/dummy.png" class="wdth100" alt="dummy" v-else />
          </span>
          <div class="content">
            <h4>
              {{rating.name}}
              <span>{{rating.timeAgo}}</span>
            </h4>
            <span class="star-icon">
              <star-rating
                :read-only="true"
                :increment="0.5"
                :starSize="12"
                active-color="#138808"
                :rating="Number(rating.rating)"
                :show-rating="false"
              ></star-rating>
            </span>
            <span class="user-msg">{{rating.comment}}</span>
            <ul class="image-preview" @click="galleryPopUp(rating.urls)">
              <li v-for="(productImage,index) in rating.urls" :key="index">
                <img :src="productImage" alt />
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <router-link
        :to="{path: '/product-feedback/'+ saleReferenceId }"
        tag="span"
        class="view_all_list"
        v-if="ratingObject.commentDTOs && ratingObject.commentDTOs.length > 9"
      >{{$t('viewAllFeedback')}}</router-link>
    </div>
    <div class="noreview" v-if="ratingObject.commentDTOs && ratingObject.commentDTOs.length == 0">
      <div>
        <p>{{$t('noFeedBackYet')}}</p>
        <br />
        <star-rating :read-only="true" :starSize="20" :rating="0" :show-rating="false"></star-rating>
      </div>
    </div>
    <div class="prodgallery_wrap" v-if="openProductGallery == true && galleryImageUrl.length">
      <div class="product_Gallery">
        <span class="close_prodgallery" @click="openProductGallery = !openProductGallery">
          <i class="material-icons">close</i>
        </span>
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(productImage,index) in galleryImageUrl" :key="index">
              <div class="swiper-slide">
                <div v-lazyload class="img_wrapper spinner_wrapper" v-if="productImage">
                  <ImageSpinner class="image_spinner" />
                  <img :data-url="productImage" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next">
            <i class="material-icons">arrow_forward_ios</i>
          </div>
          <div class="swiper-button-prev">
            <i class="material-icons">arrow_back_ios</i>
          </div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(productImage,index) in galleryImageUrl" :key="index">
              <div class="img_wrapper spinner_wrapper" v-if="productImage" v-lazyload>
                <ImageSpinner class="image_spinner" />
                <img :data-url="productImage" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
import StarRating from "vue-star-rating";
import Swiper from "swiper";
import "../../assets/css/swiper-slider.css";
import ImageSpinner from "../Common/ImageSpinner";
export default {
  name: "ProductFeedbackTab",
  components: {
    StarRating,
    ImageSpinner
  },
  props: {
    ratingDetails: {
      required: true,
      type: Object
    },
    saleReferenceId: {
      type: String
    },
    dataTotalRating: {
      type: String
    }
  },
  data() {
    return {
      profileImage: null,
      ratingObject: {},
      openProductGallery: false,
      galleryImageUrl: []
    };
  },
  watch: {
    ratingDetails() {
      this.ratingObject = this.ratingDetails;
    },
    openProductGallery: function(val) {
      if (val == true) {
        this.$nextTick(() => {
          var galleryThumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          });
          var galleryTop = new Swiper(".gallery-top", {
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            thumbs: {
              swiper: galleryThumbs
            }
          });
        });
      }
    }
  },
  methods: {
    galleryPopUp(id) {
      this.openProductGallery = !this.openProductGallery;
      this.galleryImageUrl = id;
    },

    openUserProfile(XAUTHID) {
      try {
        JSBridgePlugin.showNativeProfileView(XAUTHID);
      } catch (err) {
        console.log(err);
      }
    }
  },
  mounted() {
    this.ratingObject = this.ratingDetails;
  }
};
</script>
<style scoped>
.noreview {
  text-align: center;
}
.noreview .vue-star-rating {
  justify-content: center;
}
h4.heading {
  margin: 8px 0;
}
</style>